const taskList = [];

export const addTask = task => taskList.push(task);

export const runAllTasks = (deadline, callback) => {
  // Use any remaining time, or, if timed out, just run through the tasks.
  while ((deadline.timeRemaining() > 0 || deadline.didTimeout) && taskList.length > 0) {
    const task = taskList.shift();
    task();
  }

  if (taskList.length > 0) {
    requestIdleCallback(taskDeadline => runAllTasks(taskDeadline, callback), { timeout: 1000 });
  } else {
    callback();
  }
};



// WEBPACK FOOTER //
// ./scripts/utils/idleCallback.js